"use strict";

angular.module("core")
.constant("INVOICE_ATTACHMENTS_MAX", 2);



//////////////////
// WEBPACK FOOTER
// ./core/invoice-attachment/invoice-attachment.constants.js
// module id = 394
// module chunks = 0